import ReducerRegistry from '../base/redux/ReducerRegistry';
import { SET_SESSION_TIMEOUT_CONFIG, SET_SESSION_TIMEOUT_REMAINING, SET_SESSION_TIMEOUT_WARNING } from './actionTypes';
export const STORE_NAME = 'features/session-timeout';
const DEFAULT_STATE = {
    // 取れるまでは「切らない」。取得前に切ってしまう事故を無くす。
    config: {
        enabled: false,
        idleMinutes: 0,
        maxMinutes: 0
    },
    idleLeftMs: null,
    maxLeftMs: null,
    warning: null
};
// 永続化しない。部屋ごとの設定であり、次に開いたときは取り直す。
ReducerRegistry.register(STORE_NAME, (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case SET_SESSION_TIMEOUT_CONFIG:
            return {
                ...state,
                config: action.config
            };
        case SET_SESSION_TIMEOUT_REMAINING:
            return {
                ...state,
                idleLeftMs: action.idleLeftMs,
                maxLeftMs: action.maxLeftMs
            };
        case SET_SESSION_TIMEOUT_WARNING:
            return {
                ...state,
                warning: action.reason
            };
        default:
            return state;
    }
});
